import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const Spinner = () => {
	return (
		<div style={{ display: 'flex', justifyContent: 'center' }}>
			<FontAwesomeIcon icon={faSpinner} spin size='2x' />
		</div>
	);
};


export default Spinner;